<template>
    <div class="e-message-list-box">
        <div class="e-message-list" v-if="messageList.length > 0">
            <div class="e-message-info" v-for="(item,index) of messageList" :key="index">
                <div class="e-message-title">{{item.title}}</div>
                <div class="e-message-content">{{item.content}}</div>
                <div class="e-message-bar">
                    <div class="e-message-time">{{item.createTime}}</div>
                    <div class="e-message-status">
                        <el-button type="text" size="mini" @click="updateRead(item)" :loading="item.loading">已处理
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="e-message-empty" v-else>
            暂无消息
        </div>
    </div>
</template>

<script>
    import {list, read} from "@/apis/system/message";

    export default {
        name: "MessageList",
        props: [],
        data() {
            return {
                messageList: [],
                timeout: null,
                confirmVisible: false
            }
        },
        mounted() {
            this.loadData();
        },

        beforeDestroy() {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
        },

        methods: {

            loadData() {
                list().then(res => {
                    this.messageList = res.data;
                    this.$emit("updateNumber", res.data.length)
                }).catch(ex => {
                    // if (!ex.data.response || ex.data.response.status === 403) {
                    //     if (this.confirmVisible) {
                    //         return;
                    //     }
                    //     this.confirmVisible = true;
                    //     this.$confirm("网络异常或登录状态过期，是否重新登录?", "提示", {
                    //         confirmButtonText: "确定",
                    //         cancelButtonText: "取消",
                    //         type: "warning"
                    //     }).then(() => {
                    //         this.$router.replace({
                    //             path: '/login'
                    //         });
                    //     }).finally(() => {
                    //         this.confirmVisible = false;
                    //     });
                    // }
                }).finally(() => {
                    this.timeout = setTimeout(() => {
                        this.loadData();
                    }, 60000);
                })
            },
            updateRead(item) {
                if (item.loading) {
                    return;
                }
                clearTimeout(this.timeout);
                item.loading = true;
                read(item.id).then(() => {
                    this.$message.success("处理成功");
                }).finally(() => {
                    item.loading = false;
                    this.loadData();
                });
            }

        }
    }
</script>

<style scoped lang='scss'>
    .e-message-list-box {
        width: 400px;
        max-height: 600px;
        box-sizing: border-box;
        padding: 0 10px;
        overflow: auto;
    }

    .e-message-info {
        border-bottom: 1px solid #efefef;
    }

    .e-message-title {
        font-size: 14px;
        line-height: 24px;
        color: #333333;
    }

    .e-message-content {
        text-indent: 2rem;
        font-size: 14px;
        line-height: 20px;
        color: #999999;
        padding-top: 3px;
    }

    .e-message-bar {
        display: flex;
        width: 100%;
        font-size: 12px;
        height: 28px;
    }

    .e-message-time {
        width: 50%;
        text-align: left;
        color: #999999;
        line-height: 28px;
    }

    .e-message-status {
        width: 50%;
        text-align: right;
        font-size: 12px;
    }

    .e-message-empty {
        width: 100%;
        line-height: 100px;
        color: #999999;
        text-align: center;
        font-size: 14px;
    }
</style>
